import React from "react";
import { makeStyles } from "tss-react/mui";
import { Box } from "@mui/material";
import { AppLinks, AppSize, pxToRem } from "@/util";
import Header from "./header";
import { AppColors } from "@/assets/colors";
import InvestReason from "./invest";
import { reasonData as Data } from "@/util/data/serviceData";
import { IReasonData } from "@/util";
export default function Whyinvest() {
  const { classes } = styles();
  return (
    <Box className={classes.container}>
      <Header
        nav={AppLinks.PUBLIC.LISTINGS}
        name={"Why Invest with AREL?"}
        isAction={true}
        action={"Start Investing Today"}
        description={
          "With a proven track record in real estate, we provide secure, high-quality, and profitable investments for our clients"
        }
      />
      <Box className={classes.sub}>
        <InvestReason
          mainImg="/images/home/contractorImage.svg"
          reasons={Data as IReasonData[]}
        />
      </Box>
    </Box>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    minHeight: pxToRem(950),
    display: "flex",
    flexDirection: "column",
    backgroundColor: AppColors.neutral["90"],
    padding: `${pxToRem(50)} ${pxToRem(AppSize.padding)}`,
    [theme.breakpoints.down("sm")]: {
      padding: `${pxToRem(50)} ${pxToRem(30)}`,
    },
  },
  sub: {
    display: "flex",
    flex: 1,
    marginTop: theme.spacing(5),
    paddingTop: theme.spacing(3),
  },
}));
